import {
  BREAKDOWN_REPORTS_TABLE_HEADER,
  TABLEPAI,
  BREAKDOWN_REPORTS_SORT,
  BREAKDOWN_REPORTS_FILTERS,
} from "@/enums/pageEnum";
import MPTRCOM from "@/pages/report/components/MPTRCOM";

export default function MonthlyBreakdown() {
  return (
    <MPTRCOM
      tableHeader={BREAKDOWN_REPORTS_TABLE_HEADER}
      tableUrl={TABLEPAI.MONTH_BREAKDOWN}
      reportSort={BREAKDOWN_REPORTS_SORT}
      reportFilter={BREAKDOWN_REPORTS_FILTERS}
      exportUrl="/api/reports/month-breakdown/export-excel"
    />
  );
}
